import React from "react";
import { Modal, Button } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { setReadOnly } from "../../redux/slices/readOnlySlice";

function JobActionModal({ show, onHide, onEdit, jobId }) {
  const dispatch = useDispatch();

  const handleView = () => {
    dispatch(setReadOnly(true)); // Ensure this action is dispatched
    onHide();
    onEdit(jobId, false); // Proceed without checkout
  };

  const handleEdit = () => {
    dispatch(setReadOnly(false)); // Ensure this action is dispatched
    onHide();
    onEdit(jobId, true); // Proceed with checkout
  };

  return (
    <Modal show={show} onHide={onHide} centered className="job-action-modal">
      <Modal.Header closeButton>
        <Modal.Title>Job Action</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>Would you like to edit the job or view it in read-only mode?</p>
      </Modal.Body>
      <Modal.Footer className="job-action-modal-footer">
        <Button variant="secondary" onClick={handleView}>
          View
        </Button>
        <Button variant="primary" onClick={handleEdit}>
          Edit
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default JobActionModal;
